{
  "--color-primary": ["#3390EC", "#FF2BD6"],
  "--color-primary-opacity": ["#50A2E91E", "#FF2BD61F"],
  "--color-primary-opacity-hover": ["#50A2E940", "#FF2BD640"],
  "--color-primary-tint": ["#3390ec1a", "#FF2BD61A"],
  "--color-primary-shade": ["#4a95d6", "#E626C1"],
  "--color-background": ["#FFFFFF", "#160A22"],
  "--color-background-compact-menu": ["#FFFFFFBB", "#160A22DD"],
  "--color-web-app-browser": ["#FFFFFFBB", "#0303038F"],
  "--color-background-compact-menu-reactions": ["#FFFFFFEB", "#160A22EB"],
  "--color-background-compact-menu-hover": ["#00000011", "#00000066"],
  "--color-background-secondary": ["#F4F4F5", "#0A0410"],
  "--color-background-secondary-accent": ["#E4E4E5", "#1E0F30"],
  "--color-background-sidebar": ["#E4E4E5", "#11061C"],
  "--color-background-own": ["#EEFFDE", "#A71991"],
  "--color-background-own-apple": ["#DCF8C5", "#A71991"],
  "--color-background-selected": ["#F4F4F5", "#2A1742"],
  "--color-background-own-selected": ["#d0ffac", "#C21EAA"],
  "--color-chat-hover": ["#F4F4F5", "#1E0F30"],
  "--color-chat-active": ["#3390EC", "#FF2BD6"],
  "--color-chat-active-greyed": ["#60a7f0", "#A98FC9"],
  "--color-item-hover": ["#F4F4F5", "#1E0F30"],
  "--color-item-active": ["#EDEDED", "#2A1742"],
  "--color-text": ["#000000", "#F6F0FF"],
  "--color-text-secondary": ["#707579", "#A98FC9"],
  "--color-icon-secondary": ["#707579", "#A98FC9"],
  "--color-text-secondary-apple": ["#8E8E92", "#A98FC9"],
  "--color-borders": ["#DADCE0", "#2C1A45"],
  "--color-borders-input": ["#DADCE0", "#432863"],
  "--color-dividers": ["#C8C6CC", "#432863"],
  "--color-dividers-android": ["#E7E7E7", "#0A0410"],
  "--color-links": ["#3390EC", "#FF7BE8"],
  "--color-gray": ["#C4C9CC", "#6F5A92"],
  "--color-list-icon": ["#ABAFB1", "#A98FC9"],
  "--color-default-shadow": ["#72727240", "#0A04109C"],
  "--color-light-shadow": ["#7272722B", "#00000040"],
  "--color-active": ["#00C73E", "#2EE88A"],
  "--color-active-darker": ["#00a734", "#29CF7B"],
  "--color-green": ["#00C73E", "#2EE88A"],
  "--color-green-darker": ["#00A734", "#29CF7B"],
  "--color-success": ["#00C73E", "#2EE88A"],
  "--color-text-meta-colored": ["#4DCD5E", "#FF7BE8"],
  "--color-reply-hover": ["#F4F4F4", "#1E0F30"],
  "--color-reply-active": ["#E8E9E9", "#2A1742"],
  "--color-reply-own-hover": ["#D9F5CE", "#B41BA0"],
  "--color-reply-own-hover-apple": ["#cbefb7", "#B41BA0"],
  "--color-reply-own-active": ["#C5ECBE", "#C921B1"],
  "--color-reply-own-active-apple": ["#bae6a8", "#C921B1"],
  "--color-accent-own": ["#45AF54", "#FFFFFF"],
  "--color-message-meta-own": ["#4FAE4EFF", "#FFFFFF88"],
  "--color-own-links": ["#3390EC", "#FFFFFF"],
  "--color-code": ["#4a729a", "#FF7BE8"],
  "--color-code-own": ["#3c7940", "#FFFFFF"],
  "--color-code-bg": ["#70757914", "#00000080"],
  "--color-code-own-bg": ["#70757914", "#00000050"],
  "--color-composer-button": ["#707579CC", "#AAAAAACC"],
  "--color-message-reaction": ["#ebf3fd", "#2A1742"],
  "--color-message-reaction-hover": ["#c5def9", "#432863"],
  "--color-message-reaction-own": ["#c6eab2", "#7D176F"],
  "--color-message-reaction-hover-own": ["#b5e0a4", "#921B82"],
  "--color-message-reaction-chosen-hover": ["#1a82ea", "#FF2BD6"],
  "--color-message-reaction-chosen-hover-own": ["#3f9d4b", "#f5f5f5"],
  "--color-message-non-contact": ["#cceebf", "#AAAAAA"],
  "--color-voice-transcribe-button": ["#e8f3ff", "#2A1742"],
  "--color-voice-transcribe-button-own": ["#cceebf", "#A71991"],
  "--color-topic-blue": ["#2F7772", "#6ff9f0"],
  "--color-topic-yellow": ["#7F693B", "#ffd67e"],
  "--color-topic-violet": ["#8B5A96", "#cb86db"],
  "--color-topic-green": ["#44774A", "#8eee98"],
  "--color-topic-rose": ["#9B576B", "#ff93b2"],
  "--color-topic-red": ["#EB6858", "#fb6f5f"],
  "--color-topic-grey": ["#6C6C6C", "#999999"],
  "--color-forum-unread-topic-hover": ["#e9e9e9", "#1E0F30"],
  "--color-forum-hover-unread-topic-hover": ["#e2e2e2", "#2A1742"],
  "--color-chat-username": ["#3C7EB0", "#F6F0FF"],
  "--color-borders-read-story": ["#C4C9CC", "#6F5A92"],
  "--color-background-menu-separator": ["#0000001a", "#ffffff1a"],
  "--color-hover-overlay": ["#00000006", "#ffffff06"],
  "--color-toast-background": ["#202020CC", "#000000CC"]
}
